import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import { columnsAlumnosMonths } from 'components/dashboards/support-desk/unsolved-tickets/TicketsLayout';
import { dataCuotasByMonth } from 'data/apiConection.js/dataCuotas.js';
import { FaPrint } from 'react-icons/fa';
import { handle_export } from './utils';
import PropTypes from 'prop-types';

const TableCuotasByMonth = ({month}) => {
  const [cuotas, setCuotas] = useState([]);
  const [cuotasFiltered, setCuotasFiltered] = useState([]);
  const [cuotasNotPayed , setCuotasNotPayed ] = useState([]);
  const [filter, setFilter] = useState('');
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');

  // Carga inicial
  useEffect(() => {
    const fetchData = async () => {
      try {
        const cu = await dataCuotasByMonth(month);
        setCuotas(cu);
        setCuotasFiltered(cu);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [month]);

  // Filtros
  useEffect(() => {
    let cuotasFiltradas = [...cuotas];
    let cuotas_not_payed = cuotas.filter( cuota => cuota.status != 'pagado');
     setCuotasNotPayed(cuotas_not_payed);

    if (filter.trim() !== '') {
      const value = filter.toLowerCase();
      cuotasFiltradas = cuotasFiltradas.filter(cuota =>
        (cuota.firstName && cuota.firstName.toLowerCase().includes(value)) ||
        (cuota.lastName && cuota.lastName.toLowerCase().includes(value)) ||
        (cuota.status && cuota.status.toLowerCase().includes(value))
      );
    }
    if (desde || hasta) {
      const desdeDate = desde ? new Date(desde) : null;
      const hastaDate = hasta ? new Date(hasta) : null;

      cuotasFiltradas = cuotasFiltradas.filter(cuota => {
        if (!cuota.updated_at) return false;
        const updatedDate = new Date(cuota.updated_at);

        return (!desdeDate || updatedDate >= desdeDate) &&
               (!hastaDate || updatedDate <= hastaDate);
      });
    }

    setCuotasFiltered(cuotasFiltradas);
  }, [filter, desde, hasta, cuotas]);
  useEffect( ()=>{
    const filterNotPayed = () => {
      let cuotas_not_payed = cuotas.filter( cuota => cuota.status!='pagado');
      setCuotasNotPayed(cuotas_not_payed);
    }
    filterNotPayed();
  } ,[])
  const columns = columnsAlumnosMonths();

  return (
    <Row
      className="gx-4 mx-0"
      style={{
        height: '100vh',
        width: '100%',
        marginLeft: '250px',
        padding: '20px', 
      }}
    >
      {cuotasFiltered && (
        <Col style={{ height: '100%' }}>
          <AdvanceTableWrapper
            columns={columns}
            data={cuotasFiltered}
            selectionColumnWidth={52}
            sortable
            pagination
            perPage={150}
            rowCount={cuotasFiltered.length}
          >
            <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Card.Header>
                <Row className="mb-3">
                  <Col lg={4}>
                    <label>Filtro</label>
                    <input
                      type="text"
                      placeholder="Buscar por nombre, apellido o curso..."
                      className="form-control"
                      value={filter}
                      onChange={(e) => setFilter(e.target.value)}
                    />
                  </Col>
                  <Col lg={3}>
                    <label>Desde</label>
                    <input
                      title="Fecha Hasta"
                      type="date"
                      className="form-control"
                      value={desde}
                      onChange={(e) => setDesde(e.target.value)}
                    />
                  </Col>
                  <Col lg={3}>
                    <label>Hasta</label>
                    <input
                      title='Fecha Desde'
                      type="date"
                      className="form-control"
                      value={hasta}
                      onChange={(e) => setHasta(e.target.value)}
                    />
                  </Col>
                  <Col lg={1}>
                    <Button  title="Exportar todas las cuotas" onClick={() => handle_export(cuotasFiltered)}>
                      <FaPrint />
                    </Button>
                  </Col>
                  <Col lg={1}>
                    <Button title="Exportar cuotas no pagadas" onClick={() => handle_export(cuotasNotPayed)}>
                     <FaPrint className="text-warning" />

                    </Button>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body className="p-3" style={{ flexGrow: 1, overflowY: 'auto' }}>
                <AdvanceTable
                  table
                  headerClassName="bg-light text-800 align-middle"
                  rowClassName="btn-reveal-trigger align-middle"
                  tableProps={{
                    size: 'sm',
                    className: 'fs--1 mb-0 w-100 h-100',
                  }}
                />
              </Card.Body>
              <Card.Footer>
                <AdvanceTablePagination table />
              </Card.Footer>
            </Card>
          </AdvanceTableWrapper>
        </Col>
      )}
    </Row>
  );
};

TableCuotasByMonth.propTypes = {
    month : PropTypes.string,
}

export default TableCuotasByMonth;